<div class="notifications-wrapper">
  <header>
    <h2>
      <span *ngIf="workspaceNotifications">Workspace </span
      >Notifications
    </h2>
    <div class="close-icon" (click)="close()"></div>
  </header>
  <div
  class="notifications-list"
  *ngIf="notifications?.length > 0; else elseBlock"
  >
  <div class="upload-loading" *ngIf="isLoading">
    <div>
      <img src="assets/img/ajax-loader.gif" alt="Loading" /> <br />Loading...
    </div>
  </div>
    <div *ngIf="hasUnreadConversations">
      You have new unread Conversation Messages
    </div>
    <div
      class="item"
      *ngFor="let notification of notifications"
      [ngClass]="{ read: notification.read == true }"
      (click)="calculateRouterLink(notification)"
    >
      <div class="left">
        <div class="avatar avatar-32">
          <div
            class="avatar-inicitials"
            initials
            [name]="notification.notification.display_message.workspace"
          ></div>
          <!-- API must return the initials/avatar -->
        </div>
      </div>
      <div class="right">
        <div class="date">
          {{
            notification.notification.created_at
              | amFromUtc
              | amLocal
              | amCalendar: moment_calendar_format
          }}
        </div>
        <div class="notification">
          <span *ngIf="notification.notification.display_message.actor">
            {{ notification.notification.display_message.actor }}</span
          >
          <span *ngIf="notification.notification.display_message.action">
            <strong
              class="action {{
                notification.notification.display_message.action
              }}"
            >
              {{ notification.notification.display_message.action }}</strong
            ></span
          >
          <span *ngIf="notification.notification.display_message.action_text">
            {{ notification.notification.display_message.action_text }}</span
          >
          <span *ngIf="notification.notification.display_message.object_type">
            in {{ notification.notification.display_message.object_type }}</span
          >
          <span *ngIf="notification.notification.display_message.object_name">
            {{ notification.notification.display_message.object_name }}</span
          >
          <span *ngIf="notification.notification.display_message.workspace">
            in
            <strong>{{
              notification.notification.display_message.workspace
            }}</strong></span
          >.
        </div>
      </div>
    </div>
    <div class="load-more-wrapper" *ngIf="canLoadMore">
      <button class="btn btn-primary-light" (click)="loadMore()">
        Load More
      </button>
    </div>
  </div>
  <ng-template #elseBlock>
    <div class="empty-wrapper">
      <div class="upload-loading" *ngIf="isLoading">
        <div>
          <img src="assets/img/ajax-loader.gif" alt="Loading" /> <br />Loading...
        </div>
      </div>
      <div *ngIf="!isLoading">
        <div class="emoji">✨</div>
        <h4>Yay!</h4>
        <p>Everything's clean.</p>
      </div>
    </div>
  </ng-template>
</div>
<div class="notifications-backdrop" (click)="close()"></div>
